import { render, staticRenderFns } from "./SearchPageLoadingIndicator.vue?vue&type=template&id=7977dce8&"
import script from "./SearchPageLoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./SearchPageLoadingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/juhani/ddev/aidian-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7977dce8', component.options)
    } else {
      api.reload('7977dce8', component.options)
    }
    module.hot.accept("./SearchPageLoadingIndicator.vue?vue&type=template&id=7977dce8&", function () {
      api.rerender('7977dce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/SearchPageLoadingIndicator.vue"
export default component.exports